import lookConversionUtils from './lookconversion';
import {get, listAll, post} from './utils';

const dao = {
  initLook: () => lookConversionUtils.init,
  queryLook: async lookId =>
    lookConversionUtils.fromDb(
      await get('/smb-backend/look/query-look.action', {lookId})
    ),
  listAllLooks: params => listAll(dao.listLooks, params),
  listLooks: async params =>
    lookConversionUtils.fromDb(
      await get('/smb-backend/look/list-looks.action', params)
    ),
  createLook: async look =>
    lookConversionUtils.fromDb(
      await post(
        '/smb-backend/look/create-look.action',
        lookConversionUtils.toDb(look)
      )
    ),
  updateLook: async look =>
    lookConversionUtils.fromDb(
      await post(
        '/smb-backend/look/update-look.action',
        lookConversionUtils.toDb(look)
      )
    ),
  deleteLook: lookId => get('/smb-backend/look/delete-look.action', {lookId}),
  existLookNo: (lookId, lookNo) =>
    get('/smb-backend/look/exist-look-no.action', {lookId, lookNo}),
  countEnabled: () => get('/smb-backend/look/count-enabled.action'),
  listSkuIds: () => get('/smb-backend/look/list-sku-ids.action'),
};

export default dao;
